<template>
  <div @scroll="scroll">
    <slot name="content" />
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>

export default {
  name: "ScrollableContent",
  props: {
  },
  methods: {
    scroll(e) {
      if (
        e.target.clientHeight &&
        e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight
      ) {
        this.$emit("scroll-end");
      }
    }
  }
};
</script>
